import Vue from 'vue'
import VtLoadingView from '@/components/common/vt-loading-view/vt-loading-view.vue'
Vue.component('VtLoadingView', VtLoadingView)
